import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { WorkflowExec } from 'app/models/workflow-exec';
import { FormSubmission } from 'app/models/form-submission';
import { FormFillerComponent } from 'app/views/form-filler/form-filler.component';
import { FormTemplateService } from 'app/services/form-template.service';
import { finalize } from 'rxjs/operators';
import { WorkflowExecFile } from 'app/models/workflow-exec-file';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';

@Component({
  selector: 'app-workflow-exec-materials-details',
  templateUrl: './workflow-exec-materials-details.component.html',
  styleUrls: ['./workflow-exec-materials-details.component.scss']
})
export class WorkflowExecMaterialsDetailsComponent implements OnInit {

  @Input() workflowExec: WorkflowExec = null;
  @Input() isExternal: boolean = false;
  
  // For external requests
  @Input() contactId: number = null;
  @Input() token: string = null;

  isLoading: boolean = false;

  @ViewChild('formFiller') formFiller: FormFillerComponent;

  constructor(private formTemplateService: FormTemplateService, private workflowExecutionService: WorkflowExecutionService) { }

  ngOnInit(): void {
  }

  viewFormSubmission(formSubmission: FormSubmission) {
    if (formSubmission.template) {
      this.formFiller.show(formSubmission.template, formSubmission, null, null, false, true, true);
    } else {
      this.isLoading = true;
      this.formTemplateService.getById(formSubmission.template_id).pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe((f) => {
        formSubmission.template = f;
        this.formFiller.show(f, formSubmission, null, null, false, true, true);
      });
    }
  }

  downloadFile(file: WorkflowExecFile) {
    if (this.isExternal) {
      this.workflowExecutionService.downloadFileExternal(this.workflowExec.id, file.file_name, this.contactId, this.token);
    } else {
      this.workflowExecutionService.downloadFile(this.workflowExec.id, file.file_name);
    }
  }
  
  innerWidth() {
    return window.innerWidth;
  }
}
